import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../../types'
import {
  OpenPanelMainContentLeftRowData
} from '../../../open-panel/open-panel-containers/open-panel-main-content-left/open-panel-main-content-left-row/open-panel-main-content-left-row.component.converter'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionMainContentLeftRowConverter extends CmsConverterService<AccordionMainContentLeftRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      rows: formData.st_rows ?? defaultFSCatalog,
      text: formData.st_accordion_row_headline ?? defaultTextInput,
      fullwidth: formData?.st_full_width?.value ?? false,
    }
  }
}

export const ACCORDION_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionMainContentLeftRowConverter>>('AccordionMainContentLeftRowConverter')

export interface AccordionMainContentLeftRowData extends ConvertedComponentData {
  rows: FsCatalog<OpenPanelMainContentLeftRowData>;
  text: TextInput;
  fullwidth: boolean;
}
